<template>
  <div class="card">
    <!-- tablero -->
    <nav class="nav">
      <img src="assets/layout/educacion/header.png" alt="" />
    </nav>

    <div class="row ml-3 mt-2 mb-4" v-if="!loading">
      <div class="col-sm-2">
        <div class="dropdown bg-whites">
          <div class="fondo text-center">
            <h6 class="card-title pt-2 pb-2">UGEL</h6>
          </div>

          <button
            class="btn btn-lite dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Todas
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" href="#">Opción 1</a>
            <a class="dropdown-item" href="#">Opción 2</a>
            <a class="dropdown-item" href="#">Opción 3</a>
          </div>
        </div>
      </div>
      <div class="col-sm-6 text-center">
        <div class="titulo-table">
          <h6 class="card-title">
            DISTRIBUCIÓN DE MATERIALES EDUCATIVOS
            <br />
            <div class="letra-amarilla">SEGÚN CCDD</div>
          </h6>
        </div>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col"># Ugel</th>
              <th scope="col">Nombre ugel</th>
              <th scope="col">Cantidad CCDD</th>
              <th scope="col">Cantidad NEA UGEL</th>
              <th scope="col">Cantidad Pecosa Ugel</th>
              <th scope="col">Avance</th>
            </tr>
          </thead>
        </table>
        <div class="scrollable-table">
          <table class="table table-striped">
            <tbody>
              <tr v-for="modulo in listTotal" :key="modulo.codigo_ugel">
                <td>{{ modulo.codigo_ugel }}</td>
                <td>{{ modulo.nombre_ugel }}</td>
                <td>{{ modulo.ccdd }}</td>
                <td>{{ modulo.nea_almancen }}</td>
                <td>{{ modulo.pecosa }}</td>
                <td>{{ modulo.avance }}%</td>
              </tr>
            </tbody>
          </table>
        </div>
        <table class="table table-striped">
          <tfoot>
            <tr>
              <td class="bold">Total</td>
              <td class="bold"></td>
              <td class="bold">{{ totales.totalCcdd }}</td>
              <td class="bold">{{ totales.totalNeaAlmacen }}</td>
              <td class="bold">{{ totales.totalPecosa }}</td>
              <td class="bold">{{ totales.porAvance }}%</td>
            </tr>
          </tfoot>
        </table>

        <div class="titulo-table">
          <h6 class="card-title">PECOSAS FIRMADOS / POR FIRMAR</h6>
        </div>
        <div class="scrollable-table">
          <table class="table table-striped .scrollable-table">
            <thead>
              <tr>
                <th scope="col">Ugel</th>
                <th scope="col">ATENDIDO</th>
                <th scope="col">PECOSAS POR FIRMAR</th>
                <th scope="col">TOTAL</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Mark</td>
                <td>Mark</td>
                <td>Otto</td>
                <td>@mdo</td>
              </tr>
              <tr>
                <td>Mark</td>
                <td>Jacob</td>
                <td>Thornton</td>
                <td>@fat</td>
              </tr>
              <tr>
                <td>Mark</td>
                <td>Larry the Bird</td>
                <td>@twitter</td>
                <td>@mdo</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td class="bold">Total</td>
                <td class="bold">$60</td>
                <td class="bold">$60</td>
                <td class="bold">{{ listTotal.length }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <div class="row col-sm-4">
        <div class="col-sm-6 mb-3">
          <div class="card mb-3 fondo3">
            <div class="card-body">
              <h5 class="text-center">TOTAL MATERIALES</h5>
            </div>
          </div>
          <div class="card mb-3 fondo2">
            <div class="card-body text-center">
              <h6 class="card-title">MATERIALES PROGRAMADOS</h6>
              <h2 class="card-text">531,666</h2>
            </div>
          </div>
          <div class="card mb-3 fondo2">
            <div class="card-body text-center">
              <h6 class="card-title">MATERIALES ENTREGADOS</h6>
              <h2 class="card-text">472,889</h2>
            </div>
          </div>

          <div class="">
            <div class="text-center">
              <div class="fondo2 borde-gris">
                <h6 class="card-title fondo pt-2 pb-1">
                  ESTADO <br />
                  <div class="card-title letra-amarilla">FALTANTES</div>
                </h6>
                <div class="fondo2 borde-gris">
                  <h2 class="card-text pb-3">58,777</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="card mb-3 fondo3">
            <div class="card-body">
              <h5 class="text-center">TOTAL >PECOSA</h5>
            </div>
          </div>
          <div class="card mb-3 fondo2">
            <div class="card-body text-center">
              <h6 class="card-title">TOTAL DE PECOSAS</h6>
              <h2 class="card-text">16,597</h2>
            </div>
          </div>
          <div class="card mb-3 fondo2">
            <div class="card-body text-center">
              <h6 class="card-title">PECOSA ATENDIDO</h6>
              <h2 class="card-text">14,901</h2>
            </div>
          </div>

          <div class="">
            <div class="text-center">
              <div class="fondo2 borde-gris">
                <h6 class="card-title fondo pt-2 pb-1">
                  PECOSAS<br />
                  <div class="card-title letra-amarilla">POR FIRMAR</div>
                </h6>
                <div class="fondo2 borde-gris">
                  <h2 class="card-text pb-3">1,696</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="text-center">
            <div class="">
              <h6 class="card-title fondo pt-2 pb-1">
                % DE AVANCE DISTRIBUCIÓN
              </h6>
              <div class="">
                <canvas id="myCanvas" width="200" height="200"></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- tablero -->
    <div class="card header-inclusion">
      <img
        src="assets/layout/educacion/portada_educacion_fotos.jpg"
        alt="GSObservatorio saneamiento portada"
      />
    </div>

    <div class="p-grid mt-4 p-justify-center" style="gap: 20px">
      <div
        v-for="modulo in embedList"
        :key="modulo.id"
        class="card p-col-12 p-md-6 p-lg-3 pointer"
        @click="goTo(modulo.url)"
      >
        <a class="text-center">
          <img
            :src="'assets/layout/educacion/' + modulo.image"
            :alt="modulo.nombre"
            style="width: 250px; height: 250px"
          />
        </a>
        <div class="content">
          <h4 class="p-text-bold text-color-grsm text-center">
            {{ modulo.entidad }}
          </h4>
          <p class="text-center" style="font-size: 18px">
            {{ modulo.nombre }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { useEdutionStore } from "@/store/educacion/educacion";
//import baseURL from "@/utilities/constantes";
/* import { useEdutionStore } from "@/store/educacion/educacion"; */
///import { useEmbedStore } from "@/store/embedStore";
/*
import GastosPresupuestoCorrientes from "../components/GastosPresupuestoCorrientes.vue"; */
//import { useEmbedStore } from "@/store/embedStore";
/* import EducacionMaterialVue from '../../components/EducacionMaterial.vue'; */

export default {
  data() {
    return {
      isLoading: true,
      embedList: [
        {
          id: 7,
          entidad: "ANALISIS DE COBERTURA DE DOCENTES 2024",
          //url: "https://app.powerbi.com/view?r=eyJrIjoiMjlkNjYxYjItOTFiNC00OGY2LThiNjMtM2I5MzQ4ZTgzMjgzIiwidCI6IjJlNTdhM2ZlLTkzZjQtNDhiNC04Yzg2LTM0ZmVlYzliNTI1NyJ9&pageName=ReportSection",
          url: "https://app.powerbi.com/view?r=eyJrIjoiYjhmNTg1MzYtYzVjYy00OTEwLTg2MjUtZTNiM2IzZGE4ODAwIiwidCI6IjJlNTdhM2ZlLTkzZjQtNDhiNC04Yzg2LTM0ZmVlYzliNTI1NyJ9",
          nombre:
            "Contratación de docente en San Martín",
          image: "contratacion.png",
        },
        {
          id: 6,
          entidad: "COMPROMISOS DE DESEMPEÑO",
          //url: "https://app.powerbi.com/view?r=eyJrIjoiMjlkNjYxYjItOTFiNC00OGY2LThiNjMtM2I5MzQ4ZTgzMjgzIiwidCI6IjJlNTdhM2ZlLTkzZjQtNDhiNC04Yzg2LTM0ZmVlYzliNTI1NyJ9&pageName=ReportSection",
          url: "https://app.powerbi.com/view?r=eyJrIjoiNzA0YzRmMGYtNmYxMS00ODFkLWI0YjQtMjg4YjA1MzJiZGUxIiwidCI6IjJlNTdhM2ZlLTkzZjQtNDhiNC04Yzg2LTM0ZmVlYzliNTI1NyJ9",
          nombre:
            "Compromiso de desempeño 2025",
          image: "desempenio.png",
        },
        {
          id: 5,
          entidad: "HOMOLOGACIÓN DE NIÑOS Y NIÑAS DE 3 AÑOS",
          //url: "https://app.powerbi.com/view?r=eyJrIjoiMjlkNjYxYjItOTFiNC00OGY2LThiNjMtM2I5MzQ4ZTgzMjgzIiwidCI6IjJlNTdhM2ZlLTkzZjQtNDhiNC04Yzg2LTM0ZmVlYzliNTI1NyJ9&pageName=ReportSection",
          //url: "https://app.powerbi.com/view?r=eyJrIjoiM2IxZDk2ZDktZjA5ZS00OWE3LTk0OTgtYmQyN2UxOWRiMmE2IiwidCI6IjJlNTdhM2ZlLTkzZjQtNDhiNC04Yzg2LTM0ZmVlYzliNTI1NyJ9",
          url: "https://app.powerbi.com/view?r=eyJrIjoiNzEzNjM3OTItN2Q1Yi00YTAwLTllN2ItZTQyNmZkMjc0MDdhIiwidCI6IjJlNTdhM2ZlLTkzZjQtNDhiNC04Yzg2LTM0ZmVlYzliNTI1NyJ9",
          nombre:
            "Cantidad de niños y niñas de 3 años homologados y por homologar en el nivel inicial por provincia y distrito",
          image: "homologacion-edad3.png",
        },
        {
          id: 4,
          entidad: "MOBILIARIO Y EQUIPAMIENTO DE  II.EE EN LA REGIÓN SAN MARTÍN",
          url: "https://app.powerbi.com/view?r=eyJrIjoiZDU2NTljYzAtYWU2ZS00MGE2LWFjOGEtYWQyM2IyNGNiNzQ0IiwidCI6IjJlNTdhM2ZlLTkzZjQtNDhiNC04Yzg2LTM0ZmVlYzliNTI1NyJ9",
          nombre:
            "Mobiliario y equipamiento",
          image: "materiales.png",
        },
        {
          id: 1,
          entidad: "EGRESADOS DE NIVEL PRIMARIO",
          url: "https://app.powerbi.com/view?r=eyJrIjoiN2EyNzI0ZGItYTJkYS00ZDA0LWEzNjAtMjRlNjUwZWNhZTRmIiwidCI6IjJlNTdhM2ZlLTkzZjQtNDhiNC04Yzg2LTM0ZmVlYzliNTI1NyJ9",
          nombre:
            "Porcentaje de estudiantes egresados del nivel de educación primaria que se matriculan en el primer grado de secundaria",
          image: "egresados.png",
        },
        {
          id: 2,
          entidad: "PERMANENCIA EN NIVEL DE SECUNDARIA",
          url: "https://app.powerbi.com/view?r=eyJrIjoiYTI0NmMzZDUtNzAyMS00OTI4LWE1MmUtMjY1ZjdhYmY4MjEzIiwidCI6IjJlNTdhM2ZlLTkzZjQtNDhiNC04Yzg2LTM0ZmVlYzliNTI1NyJ9",
          nombre:
            "Porcentaje de estudiantes del nivel secundaria de la EBR que permanecen matriculados en los servicios educativos",
          image: "matriculados.png",
        },
        {
          id: 3,
          entidad: "SERVICIOS BÁSICOS",
          //url: "https://app.powerbi.com/view?r=eyJrIjoiMjlkNjYxYjItOTFiNC00OGY2LThiNjMtM2I5MzQ4ZTgzMjgzIiwidCI6IjJlNTdhM2ZlLTkzZjQtNDhiNC04Yzg2LTM0ZmVlYzliNTI1NyJ9&pageName=ReportSection",
          url: "https://app.powerbi.com/view?r=eyJrIjoiOTAzZGE3NDMtMWU4OC00OWJmLTg3NmEtNTY2MTc5YjBhMmNhIiwidCI6IjJlNTdhM2ZlLTkzZjQtNDhiNC04Yzg2LTM0ZmVlYzliNTI1NyJ9",
          nombre:
            "Pago oportuno mensual de servicios básicos de las IIEE de EBR, EBA, EBE, ISP e IST II TRAMO",
          image: "servicio.png",
        },
      ],
      listTotal: [],
      loading: true,
      totales: {
        totalCcdd: 0,
        totalNeaAlmacen: 0,
        totalPecosa: 0,
        avance: 0,
      },
      avanceTotal: 0,
    };
  },
  components: {
    /*  GastosPresupuesto,
    GastosPresupuestoCorrientes, */
    /*  EducacionMaterialVue */
  },
  productService: null,
  eventService: null,

  mounted() {
    //this.loadEmbed();
    this.getAllDatos();
  },
  methods: {
    goTo(link) {
      window.location.href = link;
    },
    async getAllDatos() {
      this.loading = true;
      const educacionStore = useEdutionStore();
      let response = await educacionStore.getTotalCantidad();
      this.listTotal = response.data.data.dataByCodigoUgel;
      const ccddTotal = this.listTotal.reduce(
        (total, item) => total + item.ccdd,
        0
      );
      const pecosaTotal = this.listTotal.reduce(
        (total, item) => total + item.pecosa,
        0
      );
      const neaAlmacenTotal = this.listTotal.reduce(
        (total, item) => total + item.nea_almancen,
        0
      );

      const avanceTotal = this.listTotal.reduce(
        (total, item) => total + item.avance,
        0
      );
      this.avanceTotal = avanceTotal;
      this.totales = {
        totalCcdd: ccddTotal,
        totalNeaAlmacen: neaAlmacenTotal,
        totalPecosa: pecosaTotal,
        porAvance: parseInt(avanceTotal / this.listTotal.length),
      };

      this.loading = false;
    },
  },
  computed: {
    ...mapGetters({ items: "gsdialogoauth/getMenu" }),
  },
};
</script>
<style lang="scss">
.card {
  border-radius: 15px;
}
.btn-danger {
  background-color: #7b1f2d;
}
.btn-danger:hover {
  background-color: #7b1f2d;
}
.titulo-table {
  background-color: #7b1f2d;
  color: #fff;
  border-radius: 15px 15px 0 0;
  padding-top: 10px;
  padding-bottom: 1px;
}
.nav img {
  width: 100%;
  height: 90%;
}
.fondo {
  background-color: #7b1f2d;
  color: white;
  font-weight: 600;
  border-radius: 15px 15px 0 0;
}

.fondo2 {
  background-color: #7d858c;
  color: #fff;
}
.fondo3 {
  background-color: #7b1f2d;
  color: white;
  font-weight: 600;
  border-radius: 15px 15px 15px 15px;
}
.letra-amarilla {
  color: #e2a948;
}
.dropdown-toggle {
  margin-top: -20px;
  width: 100%;
  outline: none !important;
  box-shadow: none !important;
}
.dropdown-menu.show {
  width: 100%;
}
.dropdown-item.active,
.dropdown-item:active {
  background-color: #7b1f2d; /* Cambia este valor al color deseado */
}
.borde-gris {
  border-radius: 15px 15px 15px 15px;
}
.bold {
  font-weight: bold;
}

/* medidor porcentaje */

.scrollable-table {
  max-height: 400px; /* Establece la altura máxima para la tabla */
  overflow-y: auto; /* Agrega una barra de desplazamiento vertical cuando se excede la altura */
}

.header-inclusion {
  margin-bottom: 0px;
  border-radius: 0px;
  padding: 0px;
}

.text-color-grsm {
  color: #822737;
}

.pointer {
  cursor: pointer;
}
</style>
